"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProbeSetupGuide = void 0;
exports.showProbeSetupGuide = showProbeSetupGuide;
const Leaf = __importStar(require("leaf-ts"));
const web_1 = require("@branch-ts/web");
const web_consensus_1 = require("@branch-ts/web-consensus");
const with_caution_1 = require("with-caution");
const probeSetupGuide_html_R_1 = require("./probeSetupGuide.html.R");
const probeSetupGuide_html_R_2 = require("./probeSetupGuide.theme/genesis/probeSetupGuide.html.R");
const probeSetupGuide_html_R_3 = require("./probeSetupGuide.theme/business/probeSetupGuide.html.R");
const versetFacilityMechanism_1 = require("../versetFacilityMechanism");
const probeInstallCommand_1 = require("../probeInstallCommand");
// Product truth for this guide lives in ../../../../doc/src/md/devices/index.md.
// Keep this pairing UI and that guide aligned whenever installer, platform, or security behavior changes.
const nvmVersion = "v0.40.3";
const nodeVersion = "24.22.1";
const otpRefreshRatio = .5;
let setupWindow;
function showProbeSetupGuide() {
    if (setupWindow) {
        void setupWindow.show();
        return;
    }
    const guide = new ProbeSetupGuide({
        onConnected: () => {
            if (setupWindow?.widget === guide)
                setupWindow.hide();
        },
    });
    const window = new web_1.WindowBehavior(guide, "mini")
        .setTitle("Set up your local Probe")
        .customizeBoxStyle({
        width: "100%",
        maxWidth: "700px",
        height: "auto",
        maxHeight: "90%",
    });
    setupWindow = window;
    window.events.listenBy(guide, "hide", () => {
        if (web_1.WindowBehavior.windows.includes(window)) {
            return; // Minimized, not closed: keep the same guide and pairing code.
        }
        guide.dispose();
        if (setupWindow === window) {
            setupWindow = undefined;
        }
    });
    void guide.initialize();
    void window.show();
}
class ProbeSetupGuide extends probeSetupGuide_html_R_1.R.ProbeSetupGuide {
    constructor(option = {}) {
        super();
        this.option = option;
        this.stages = new web_1.StagesBehavior(this).defines({
            installMode: "manual",
            platform: "linux",
            connectionSummary: "hidden",
        });
        this.expiresAt = 0;
        this.code = "";
        this.refreshTimer = null;
        this.disposed = false;
        this.checkingDeviceStatus = false;
        this.issuedPairingIds = new Set();
        this.issueGeneration = 0;
        this.completed = false;
        this.present = web_consensus_1.PresentMechanism.ensure(this);
        this.selectInstallMethod(detectInstallMethod());
        if (!option.route) {
            return;
        }
        // Navigation mounts the root before applying URL parameters. Do not
        // start an unconfigured cycle that configure() would dismiss immediately.
        this.present
            .requireConfig()
            .route(async () => undefined)
            .lifeCycle(async (declares) => {
            await declares.declare("configure");
            await declares.declare("present");
            await this.initialize();
            await declares.declare("hang");
            this.dispose();
            await declares.declare("dismiss");
        });
    }
    initialize() {
        if (this.disposed)
            return Promise.resolve();
        return this.initializationTask ??= this.initializePairing();
    }
    async initializePairing() {
        const app = versetFacilityMechanism_1.VersetFacilityMechanism.app;
        this.manager = app?.getServiceByName("VersetProbeService")?.probeSessionManager
            || app?.getServiceByName("VersetOmniBarService")?.probeOmniSupport?.probeSessionManager;
        this.manager?.events.listenBy(this, "change", () => {
            this.syncConnectionSummary();
            this.checkPairingCompletion();
        });
        this.syncConnectionSummary();
        await this.issueCode();
    }
    syncConnectionSummary() {
        if (this.disposed)
            return;
        // Use the same known-device roster and direct connection state as Devices/Omni.
        // Candidate availability or code redemption alone does not mean connected.
        const entries = Array.from(this.manager?.probeEntryRegistry.values() || []);
        const connected = entries.filter(entry => entry.situations.get("online")).length;
        this.VM.connectionSummary = connected > 0
            ? `${connected}/${entries.length} devices connected`
            : "";
        this.stages.set("connectionSummary", connected > 0 ? "visible" : "hidden");
    }
    checkPairingCompletion() {
        if (this.disposed || this.completed || !this.manager)
            return;
        const entry = this.manager.getReadyPairedProbe(this.issuedPairingIds);
        if (!entry)
            return;
        this.completed = true;
        this.VM.pairingStatus = "Device connection established.";
        this.dispose();
        if (this.option.route)
            web_consensus_1.UIMechanism.goto({ uri: "/" });
        else
            this.option.onConnected?.();
        web_consensus_1.CommonUI.toast(`${entry.displayName || "Device"} connected. Keep its Probe terminal running.`);
    }
    dispose() {
        this.disposed = true;
        this.issueGeneration++;
        this.manager?.events.stopListenBy(this);
        if (this.refreshTimer) {
            clearTimeout(this.refreshTimer);
            this.refreshTimer = null;
        }
    }
    onClickLinuxTab(e) {
        e?.preventDefault();
        e?.stopPropagation();
        this.selectInstallMethod("linux");
    }
    onClickMacOSTab(e) {
        e?.preventDefault();
        e?.stopPropagation();
        this.selectInstallMethod("macOS");
    }
    onClickWslTab(e) {
        e?.preventDefault();
        e?.stopPropagation();
        this.selectInstallMethod("wsl");
    }
    onClickAgentTab(e) {
        e?.preventDefault();
        e?.stopPropagation();
        this.selectInstallMethod("agent");
    }
    selectInstallMethod(installMethod) {
        this.stages.set("installMode", installMethod === "agent" ? "agent" : "manual");
        if (installMethod !== "agent") {
            this.stages.set("platform", installMethod);
        }
        this.VM.linuxTabClass = installMethod === "linux" ? "active" : "";
        this.VM.macOSTabClass = installMethod === "macOS" ? "active" : "";
        this.VM.wslTabClass = installMethod === "wsl" ? "active" : "";
        this.VM.agentTabClass = installMethod === "agent" ? "active" : "";
        this.VM.copyNotice = "";
    }
    onClickCopyCommand(e) {
        e?.preventDefault();
        e?.stopPropagation();
        void this.copyCommand();
    }
    onClickRefreshCode(e) {
        e?.preventDefault();
        e?.stopPropagation();
        void this.issueCode();
    }
    onClickCopyCode(e) {
        e?.preventDefault();
        e?.stopPropagation();
        void this.copyCode();
    }
    onClickCopySkill(e) {
        e?.preventDefault();
        e?.stopPropagation();
        void this.copySkill();
    }
    async onClickCheckDeviceStatus(e) {
        e?.preventDefault();
        e?.stopPropagation();
        if (this.disposed || this.checkingDeviceStatus) {
            return;
        }
        this.checkingDeviceStatus = true;
        this.UI.checkDeviceStatus.disabled = true;
        try {
            const support = versetFacilityMechanism_1.VersetFacilityMechanism.ensureApp()
                .getServiceByName("VersetOmniBarService")?.probeOmniSupport;
            if (!support) {
                throw new Error("Device status is not ready yet. Please try again shortly.");
            }
            await support.showProbeExplorerWindow();
            const [, reason, ...errors] = await support.probeSessionManager.sync();
            if (reason) {
                throw with_caution_1.CautionUtil.error(reason, ...errors);
            }
        }
        catch (error) {
            if (!this.disposed) {
                web_consensus_1.CommonUI.error(error);
            }
        }
        finally {
            this.checkingDeviceStatus = false;
            this.UI.checkDeviceStatus.disabled = false;
        }
    }
    async copyCommand() {
        if (!this.code) {
            this.VM.copyNotice = "Create a pairing code before copying the run command.";
            return;
        }
        try {
            await globalThis.navigator?.clipboard?.writeText(createRunCommand(this.code));
            this.VM.copyNotice = this.stages.get("platform") === "wsl"
                ? "Copied. Run it in Ubuntu, not PowerShell or Command Prompt. Keep Ubuntu open."
                : "Copied. Run it in your local terminal and keep that terminal open.";
        }
        catch {
            this.VM.copyNotice = this.stages.get("platform") === "wsl"
                ? "Copy the command above, then run it in Ubuntu, not PowerShell or Command Prompt."
                : "Copy the command above, then run it in your local terminal.";
        }
    }
    async copyCode() {
        if (!this.code) {
            this.VM.pairingStatus = "Create a pairing code before copying it.";
            return;
        }
        try {
            await globalThis.navigator?.clipboard?.writeText(this.code);
            this.VM.pairingStatus = "Pairing code copied. Paste it if the Probe asks.";
        }
        catch {
            this.VM.pairingStatus = "Select the pairing code above and copy it into the Probe.";
        }
    }
    async copySkill() {
        if (!this.code) {
            this.VM.skillNotice = "Create a pairing code before copying the agent skill.";
            return;
        }
        try {
            await globalThis.navigator?.clipboard?.writeText(createAgentInstallSkill(this.code));
            this.VM.skillNotice = "One-use agent skill copied.";
        }
        catch {
            this.VM.skillNotice = "Select the agent skill above and copy it to your agent.";
        }
    }
    async issueCode() {
        if (this.disposed) {
            return;
        }
        const generation = ++this.issueGeneration;
        if (this.refreshTimer)
            clearTimeout(this.refreshTimer);
        this.refreshTimer = null;
        this.code = "";
        this.VM.code = "········";
        this.VM.runCommand = "Creating a secure pairing code…";
        this.VM.agentSkill = "";
        this.VM.copyNotice = "";
        this.VM.skillNotice = "";
        this.VM.pairingStatus = "Creating a secure one-time code…";
        const server = versetFacilityMechanism_1.VersetFacilityMechanism.ensureServer();
        const [otp, reason] = await server.rpcs.VersetUserProbeService.issueMyProbeOTP({});
        if (this.disposed) {
            return;
        }
        // A copied older code remains valid after refresh. Track every successful issuance.
        if (otp?.pairingId) {
            this.issuedPairingIds.add(otp.pairingId);
            this.checkPairingCompletion();
        }
        if (this.disposed || generation !== this.issueGeneration)
            return;
        if (reason || !otp) {
            this.VM.code = "Unavailable";
            this.VM.runCommand = "A pairing code could not be created.";
            this.VM.agentSkill = "A pairing code could not be created. Create a new code before sharing an agent skill.";
            this.VM.pairingStatus = "We could not create a pairing code. Check your connection and try again.";
            return;
        }
        this.expiresAt = otp.expiresAt;
        this.code = otp.code;
        this.VM.code = formatPairingCode(this.code);
        this.VM.runCommand = createRunCommand(this.code);
        this.VM.agentSkill = createAgentInstallSkill(this.code);
        this.VM.skillNotice = "";
        this.syncExpiryNotice();
        this.scheduleRefresh();
    }
    syncExpiryNotice() {
        const remainingMs = Math.max(0, this.expiresAt - Date.now());
        const remainingMinutes = Math.ceil(remainingMs / 60_000);
        const hours = Math.floor(remainingMinutes / 60);
        const minutes = remainingMinutes % 60;
        this.VM.pairingStatus = hours > 0
            ? `Expires in ${hours}h ${minutes}m. It refreshes automatically.`
            : `Expires in ${minutes}m. It refreshes automatically.`;
    }
    scheduleRefresh() {
        if (this.refreshTimer) {
            clearTimeout(this.refreshTimer);
        }
        const lifetimeMs = Math.max(0, this.expiresAt - Date.now());
        this.refreshTimer = setTimeout(() => {
            void this.issueCode();
        }, lifetimeMs * otpRefreshRatio);
    }
}
exports.ProbeSetupGuide = ProbeSetupGuide;
function detectInstallMethod() {
    const platform = globalThis.navigator?.platform || globalThis.navigator?.userAgent || "";
    if (/win/i.test(platform))
        return "wsl";
    return /mac/i.test(platform) ? "macOS" : "linux";
}
function formatPairingCode(code) {
    return code.replace(/(.{4})/g, "$1 ").trim();
}
function createRunCommand(code) {
    return [
        "bash -lc 'set -euo pipefail",
        'export NVM_DIR="$HOME/.nvm"',
        'if [ ! -s "$NVM_DIR/nvm.sh" ]; then',
        `  curl -o- https://raw.githubusercontent.com/nvm-sh/nvm/${nvmVersion}/install.sh | bash`,
        "fi",
        '. "$NVM_DIR/nvm.sh"',
        `nvm install ${nodeVersion}`,
        probeInstallCommand_1.probeNpmCacheSetup,
        `nvm exec ${nodeVersion} ${probeInstallCommand_1.probeNpxCommand} --pairing-code "$1"`,
        `' -- ${quoteForShell(code)}`,
    ].join("\n");
}
function quoteForShell(value) {
    return `'${value.replace(/'/g, "'\\''")}'`;
}
function createAgentInstallSkill(code) {
    return `Install and run this computer as a Verset Probe.

On Windows, run the command inside an existing WSL2 Ubuntu environment, not directly in PowerShell or Command Prompt. WSL2 setup is experimental. If WSL2 or Ubuntu is missing, ask me to complete the Windows (WSL) setup guide, then stop; do not install WSL, reboot Windows, or change interoperability settings yourself.

Native modules require Python and a C/C++ build toolchain (macOS Command Line Tools). If these prerequisites are missing, report them instead of silently changing system packages.

Run exactly:
${createRunCommand(code)}

The command pairs the Probe and keeps it running by default. A valid code replaces this computer's previous pairing with the account that issued this code, even if the old account still exists. Stop an old Probe instance before running this command. An invalid code must not fall back to any saved account. Leave the process running so this computer stays online. Do not use the config command, stop the Probe after pairing, or treat the running command as a timeout failure.

This pairing code is single-use and expires. If Verset asks for sign-in credentials, ask me to enter them in the terminal; do not request them in chat or store them. Do not retry, prompt for another code, or use any other credentials if the command fails. Tell me to visit https://uni.verset.io/pairing for a fresh code, then stop.

If the Probe asks for a pairing code, use:
${code}`;
}
Leaf.WidgetThemeCenter.about(probeSetupGuide_html_R_1.R.ProbeSetupGuide).add("genesis", probeSetupGuide_html_R_2.R.ProbeSetupGuide.generator);
Leaf.WidgetThemeCenter.about(probeSetupGuide_html_R_1.R.ProbeSetupGuide).add("business", probeSetupGuide_html_R_3.R.ProbeSetupGuide.generator);
